<template>
  <div>
    <v-card flat>
      <v-data-table
        :loading="loading"
        :headers="invitationsHeader"
        :items="invitations"
        :single-expand="true"
        :expanded.sync="expandedInvitations"
        item-key="id"
        show-expand
        sort-by="email"
      >
        <template v-slot:top>
          <v-alert v-if="error" text dense type="error">
            {{ error }}
          </v-alert>
          <v-toolbar flat>
            <v-spacer/>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="disableAll || loading" v-on="on" text icon color="add" @click="onClickAddInvitations">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Add invitations</span>
            </v-tooltip>
          </v-toolbar>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-data-table
              dense
              :headers="subscriptionsHeader"
              :items="item.subscriptions"
              item-key="id"
              class="my-3"
              sort-by="unit.alias"

            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Devices</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:item.deleteBtn="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :loading="item.loading"
                      :disabled="disableAll"
                      small
                      icon
                      v-on="on"
                      @click="onClickRemoveInvitationSubscription(item)">
                      <v-icon color="delete">mdi-delete-forever</v-icon>
                    </v-btn>
                  </template>
                  <span>Remove from invitation</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </td>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :loading="item.resending !== undefined && item.resending"
                :disabled="disableAll"
                rounded
                small
                v-on="on"
                class="primary ma-1"
                @click="onClickResend(item)">
                <v-icon>mdi-email-sync</v-icon>
              </v-btn>
            </template>
            <span>Resend invitation</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :loading="item.deleting !== undefined && item.deleting"
                :disabled="disableAll"
                rounded
                small
                v-on="on"
                class="primary"
                @click="onClickDelete(item)">
                <v-icon color="">mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>Delete invitation</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </v-card>
    <v-dialog scrollable :value="createInvitationsModal" persistent :fullscreen="$vuetify.breakpoint.smAndDown"
              max-width="60vw">
      <InvitationsCreate @on-close="createInvitationsModal = false"/>
    </v-dialog>
  </div>
</template>

<script>
import InvitationsCreate from './InvitationsCreate'

export default {
  name: 'InvitationListExpandable',
  components: {
    InvitationsCreate
  },
  props: {
    invitations: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    createInvitationsModal: false,
    disableAll: false,
    expandedInvitations: [],
    invitationsHeader: [
      {
        text: 'Email',
        align: 'start',
        value: 'email'
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false
      }
    ],

    subscriptionsHeader: [
      {
        text: 'Alias',
        align: 'start',
        value: 'unit.alias'
      },
      {
        text: 'Subscription Number',
        value: 'subscriptionNumber'
      },
      {
        text: '',
        align: 'right',
        value: 'deleteBtn',
        sortable: false
      }
    ]
  }),

  methods: {

    onClickAddInvitations: function () {
      this.createInvitationsModal = true
    },

    onClickResend: function (invitation) {
      invitation.resending = true
      this.disableAll = true
      this.$store.dispatch('customer/resendInvitation', { id: invitation.id })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          invitation.resending = false
          this.disableAll = false
        })
    },

    onClickDelete: function (invitation) {
      invitation.deleting = true
      this.disableAll = true
      this.$store.dispatch('customer/deleteInvitation', { id: invitation.id })
        .then(response => {
          this.$store.commit('setSuccessMessage', 'Invite to ' + invitation.email + ' deleted successfully', { root: true })
        })
        .catch(error => {
          invitation.deleting = false
          console.error(error)
        })
        .finally(() => {
          invitation.deleting = false
          this.disableAll = false
        })
    },

    onClickRemoveInvitationSubscription: function (subscription) {
      subscription.loading = true
      this.disableAll = true
      this.$store.dispatch('customer/deleteInvitationSubscription', { invitation: { id: this.expandedInvitations[0].id, email: this.expandedInvitations[0].email }, subscription: subscription })
        .catch(error => {
          subscription.loading = false
          console.error(error)
        })
        .finally(() => {
          subscription.loading = false
          this.disableAll = false
        })
    }
  }
}
</script>

<style scoped>

</style>
